'use client';

import { c as _c } from "react/compiler-runtime";
import { CSSProperties, ReactNode, Suspense, lazy, useCallback, useEffect, useMemo } from 'react';
import { ToastOptions, toast } from 'react-hot-toast';
import { useNotifications, useSchemes } from '@personly/libs-providers';
import type { Icon } from '@personly/libs-types';
import { Toast } from '@personly/libs-widgets';
import { deploymentUrl } from '@personly/libs-urls';
import { toPathname } from '@personly/libs-pathnames';
const Toaster = lazy(() => import('react-hot-toast').then(module => ({
  default: module.Toaster
})));
const ToastBar = lazy(() => import('react-hot-toast').then(module => ({
  default: module.ToastBar
})));
const onNotify = async (locale: string, handle: string, substitutions: Record<string, string> = {}) => {
  const pathnames = ['translate', locale, handle];
  const url = deploymentUrl(toPathname(pathnames.join('/')));
  for (const key of Object.keys(substitutions)) {
    url.searchParams.set(key, substitutions[key]);
  }
  const response = await fetch(url);
  const {
    result
  } = await response.json();
  return result ? result.value : handle;
};
interface Props {
  children: ReactNode;
  toastIcons: Icon[];
  locale: string;
}
const Notifications = t0 => {
  const $ = _c(18);
  const {
    children,
    toastIcons,
    locale
  } = t0;
  const {
    cssVariables
  } = useSchemes();
  const {
    removeNotification,
    notifications
  } = useNotifications();
  const t1 = `1px solid ${cssVariables.toastBorderColor}`;
  let t2;
  if ($[0] !== cssVariables.toastBackgroundColor[0] || $[1] !== cssVariables.toastTextColor[0] || $[2] !== t1) {
    t2 = {
      backgroundColor: cssVariables.toastBackgroundColor[0],
      border: t1,
      color: cssVariables.toastTextColor[0],
      display: "flex",
      flex: 1,
      flexDirection: "column",
      alignItems: "normal",
      padding: 0
    };
    $[0] = cssVariables.toastBackgroundColor[0];
    $[1] = cssVariables.toastTextColor[0];
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const style = t2;
  let t3;
  if ($[4] !== toastIcons) {
    t3 = handle => toastIcons.find(icon => icon.handle === handle);
    $[4] = toastIcons;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const toastIcon = t3;
  let t4;
  let t5;
  if ($[6] !== locale || $[7] !== notifications || $[8] !== removeNotification || $[9] !== style) {
    t4 = () => {
      (async () => {
        for (const notification of notifications) {
          const options = {
            position: "top-center",
            id: notification.handle,
            duration: notification.duration,
            style
          };
          const message = await onNotify(locale, notification.handle, notification.substitutions);
          if (notification.type === "NOTICE") {
            toast(message, options);
          } else {
            if (notification.type === "SUCCESS") {
              toast.success(message, options);
            } else {
              if (notification.type === "ERROR") {
                toast.error(message, options);
              }
            }
          }
          if (notification.duration !== Infinity) {
            setTimeout(() => {
              removeNotification(notification.handle, _temp);
            }, notification.duration);
          }
        }
      })();
    };
    t5 = [notifications, removeNotification, style, locale];
    $[6] = locale;
    $[7] = notifications;
    $[8] = removeNotification;
    $[9] = style;
    $[10] = t4;
    $[11] = t5;
  } else {
    t4 = $[10];
    t5 = $[11];
  }
  useEffect(t4, t5);
  let t6;
  if ($[12] !== removeNotification) {
    t6 = id => removeNotification(id, () => toast.dismiss(id));
    $[12] = removeNotification;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const dismiss = t6;
  let t7;
  if ($[14] !== children || $[15] !== dismiss || $[16] !== toastIcon) {
    t7 = <Suspense><Toaster>{t => <ToastBar toast={t}>{t8 => {
            const {
              message: message_0
            } = t8;
            return <Toast dismiss={() => dismiss(t.id)} icon={toastIcon(t.type)} message={message_0} type={t.type}>{children}</Toast>;
          }}</ToastBar>}</Toaster></Suspense>;
    $[14] = children;
    $[15] = dismiss;
    $[16] = toastIcon;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
};
export default Notifications;
function _temp() {}